import React from 'react';
import ProductCarousel from './ProductCarousel/ProductCarousel';

const ShopPage: React.FC = () => {
  return (
    <main style={{ flexGrow: 1, display: 'flex' }}>
      <ProductCarousel />
    </main>
  );
};

export default ShopPage;